import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { useAuth } from '../contextos/AuthProvider'
import Gestion43 from './Gestion43';
import { EncApi, EncabezadoPost } from '../Comunes/Listas';

const SubirCompras = () => {
    const { PerfilUsuario, Token } = useAuth();
    const [files, setFiles] = useState([]);
    const [MisActividades, setMisActividades] = useState([{}]);
    const [dragActive, setDragActive] = useState(false);

    const inputRef = useRef(null);
    const navigate = useNavigate();

    const handleOnSubmit = async (e) => {
        if (e.which === '13') {
            e.preventDefault();
        }
        e.preventDefault();
    };

    const IniciaModulo = async () => {
        const url = 'https://SmartFeCr.com:2020/SmartContrackBack/api/SmartFeCr/CargandoDatosEnCompras?IdCia=' + PerfilUsuario.IdCia;
        const response = await fetch(url, EncApi(Token));
        const data = await response.json();
        setMisActividades(data.Actividades);
    }

    const utf8ToBase64 = (str) => {
        return btoa(unescape(encodeURIComponent(str)));
    };

    const SubirArchivosDelExplorador = async (event) => {
        const selectedFiles = Array.from(event.target.files);
        const validFiles = [];

        for (const file of selectedFiles) {
            if (file.type !== "text/xml") {
                alert(`El archivo ${file.name} no es un XML válido.`);
                continue;
            }

            const fileContent = await file.text();
            const parser = new DOMParser();
            const xmlDoc = parser.parseFromString(fileContent, "application/xml");
            const root = xmlDoc.documentElement;

            if (root) {
                const xmlns = root.getAttribute("xmlns");
                console.log(xmlns);
                let version = "";
                let tipo = "";

                switch (xmlns) {
                    case "https://cdn.comprobanteselectronicos.go.cr/xml-schemas/v4.3/notaCreditoElectronica":
                        version = "4.3";
                        tipo = "Nota Crédito";
                        break;
                    case "https://cdn.comprobanteselectronicos.go.cr/xml-schemas/v4.3/facturaElectronica":
                        version = "4.3";
                        tipo = "Factura Electrónica";
                        break;
                    case "https://cdn.comprobanteselectronicos.go.cr/xml-schemas/v4.4/facturaElectronica":
                        version = "4.4";
                        tipo = "Factura Electrónica";
                        break;
                    case "https://cdn.comprobanteselectronicos.go.cr/xml-schemas/v4.4/notaCreditoElectronica":
                        version = "4.4";
                        tipo = "Nota Crédito";
                        break;
                    default:
                        //alert(`El archivo ${file.name} no tiene un xmlns válido.`);
                        continue;
                }

                const consecutivo = root.querySelector("NumeroConsecutivo")?.textContent || "N/A";
                const proveedor = root.querySelector("Emisor > Nombre")?.textContent || "N/A";
                const fecha = root.querySelector("FechaEmision")?.textContent || "N/A";
                const total = root.querySelector("ResumenFactura > TotalComprobante")?.textContent || "N/A";
                const moneda = root.querySelector("ResumenFactura > CodigoTipoMoneda > CodigoMoneda")?.textContent || "CRC";

                validFiles.push({
                    name: file.name,
                    content: utf8ToBase64(fileContent),
                    version,
                    tipo,
                    consecutivo,
                    proveedor,
                    fecha,
                    total,
                    moneda,
                    resultado: "Sin Enviar"
                });
            }
        }

        setFiles((prevFiles) => [...prevFiles, ...validFiles]);
        localStorage.setItem("ListaCompras", JSON.stringify([...files, ...validFiles]));
    };

    const Salir = () => {
        navigate("/");
    }

    const handleRemoveFile = (index) => {
        const updatedFiles = files.filter((_, i) => i !== index);
        setFiles(updatedFiles);
        localStorage.setItem("ListaCompras", JSON.stringify(updatedFiles));
    };

    const handleSave = async () => {
        // Removed unused variable 'listaCompras'
        const lista44 = [];

        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            const fila = document.querySelectorAll("tbody tr")[i];
            const respuesta = fila.querySelector("select[name='Respuesta']").value;
            const actividad = fila.querySelector("select[name='Actividad']").value;

            if (file.version === "4.3") {
                const resultado = await Gestion43(
                    file.content,
                    file.name,
                    respuesta,
                    actividad,
                    file.tipo === "Factura Electrónica" ? "FacturaElectronica" : "NotaCreditoElectronica",
                    Token,
                    PerfilUsuario.IdCia
                );
                files[i].resultado = resultado.resultado;
                setFiles([...files]);
            } else if (file.version === "4.4") {
                lista44.push({
                    NombreArchivo: file.name,
                    TipoDocElec: file.tipo === "Factura Electrónica" ? "FacturaElectronica" : "NotaCreditoElectronica",
                    ContenidoBase64: file.content,
                    CorreoProveedor: file.CorreoProveedor || "N/A",
                    RespuestaRecepcion: respuesta,
                    Actividad: actividad,
                    IdCia: PerfilUsuario.IdCia
                });
            }
        }

        if (lista44.length > 0) {
            console.log(lista44);
            const response = await fetch("https://SmartFeCr.com:2020/SmartContrackBack/api/DocumentosElectronicos/Compras", EncabezadoPost(Token, lista44));
            const resultados = await response.json();
            console.log(resultados);
            resultados.forEach((resultado) => {
                //const fila = files.find((file) => file.NombreArchivo === resultado.NombreArchivo);
                const fila = Array.from(document.querySelectorAll("tbody tr")).find(
                    (tr) => tr.querySelector("td:nth-child(5)").textContent === resultado.NombreArchivo
                );
                if (fila) {
                    console.log(fila);
                    const fileIndex = files.findIndex(file => file.name === resultado.NombreArchivo);
                    if (fileIndex !== -1) {
                        files[fileIndex].resultado = resultado.Informacion;
                        setFiles([...files]);
                    }
                }
            });
        }

        Swal.fire({
            icon: 'success',
            title: 'Carga de archivos finalizada',
            text: 'Valide sus respuestas en la ultima columna de la tabla',
            confirmButtonText: 'OK'
        });
    };

    // ==== NUEVO: Drag & Drop UI (sin cambiar lógica del procesado) ====
    const handleDrag = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (e.type === "dragenter" || e.type === "dragover") {
            setDragActive(true);
        } else if (e.type === "dragleave") {
            setDragActive(false);
        }
    };

    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setDragActive(false);

        if (e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files.length > 0) {
            // Llama a la misma lógica, construyendo un "event" equivalente
            SubirArchivosDelExplorador({ target: { files: e.dataTransfer.files } });
            e.dataTransfer.clearData();
        }
    };

    const abrirSelector = () => {
        if (inputRef.current) inputRef.current.click();
    };

    React.useEffect(() => {
        IniciaModulo();
        // eslint-disable-next-line
    }, []);

    const styles = {
        dropzone: {
            width: '100%',
            maxWidth: '720px',
            margin: '12px 0 18px 0',
            padding: '28px 22px',
            border: dragActive ? '2px dashed #2563eb' : '2px dashed #b5b5b5',
            borderRadius: '12px',
            backgroundColor: dragActive ? '#e8f0ff' : '#fafafa',
            cursor: 'pointer',
            transition: 'all 0.2s ease',
            display: 'flex',
            alignItems: 'center',
            gap: '16px'
        },
        dzIconWrap: {
            width: '54px',
            height: '54px',
            borderRadius: '12px',
            backgroundColor: '#f1f5ff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flex: '0 0 auto'
        },
        dzIcon: {
            fontSize: '26px',
            color: '#2563eb'
        },
        dzText: {
            lineHeight: '1.25',
            color: '#111827'
        },
        dzTitle: {
            margin: 0,
            fontSize: '15px'
        },
        dzSub: {
            margin: '6px 0 0 0',
            fontSize: '12px',
            color: '#6b7280'
        },
        dzBadgeRow: {
            marginTop: '10px',
            display: 'flex',
            gap: '8px',
            flexWrap: 'wrap'
        },
        badge: {
            fontSize: '12px',
            padding: '4px 10px',
            borderRadius: '999px',
            backgroundColor: '#eef2ff',
            color: '#1e40af'
        }
    };

    return (
        <div className='main-block'>
            <div className="form" onSubmit={(e) => handleOnSubmit(e)}>
                <div className='formadoShadow'>

                    <div className='tituloPantalla'>
                        <p style={{ display: 'inline-block' }}> Compras Proveedores</p>
                        <button className="botonCerrar" style={{ backgroundColor: '#f3f3f3', width: '50px' }} id="SalirHome" onClick={Salir} name="SalirHome">
                            <i className="fa fa-times"></i>
                        </button>
                    </div>

                    <div>
                        {/* === NUEVO INPUT VISUAL (sin CSS externo) === */}
                        <div
                            style={styles.dropzone}
                            onClick={abrirSelector}
                            onDragEnter={handleDrag}
                            onDragOver={handleDrag}
                            onDragLeave={handleDrag}
                            onDrop={handleDrop}
                            title="Haga clic para seleccionar o arrastre y suelte archivos XML"
                            role="button"
                            tabIndex={0}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') abrirSelector();
                            }}
                        >
                            <div style={styles.dzIconWrap}>
                                <i className="fas fa-file-import" style={styles.dzIcon}></i>
                            </div>

                            <div style={{ flex: 1 }}>
                                <p style={styles.dzTitle}>
                                    <strong>Arrastre aquí sus XML de compra</strong> o haga clic para seleccionarlos
                                </p>
                                <p style={styles.dzSub}>
                                    Se permiten múltiples archivos. Solo se procesan Factura / Nota Crédito v4.3 y v4.4 (Hacienda CR).
                                </p>

                                <div style={styles.dzBadgeRow}>
                                    <span style={styles.badge}>.xml</span>
                                    <span style={styles.badge}>Multi-archivo</span>
                                    <span style={styles.badge}>Arrastrar & Soltar</span>
                                </div>
                            </div>
                        </div>

                        <input
                            ref={inputRef}
                            type="file"
                            accept=".xml"
                            multiple
                            hidden
                            onChange={SubirArchivosDelExplorador}
                        />

                        <table>
                            <thead>
                                <tr>
                                    <th>Remover</th>
                                    <th>Respuesta</th>
                                    <th>Actividad</th>
                                    <th>Tipo</th>
                                    <th>Archivo</th>
                                    <th>Consecutivo</th>
                                    <th>Proveedor</th>
                                    <th>Fecha del Documento</th>
                                    <th>Total</th>
                                    <th>Resultado</th>
                                </tr>
                            </thead>
                            <tbody>
                                {files.map((file, index) => (
                                    <tr key={index}>
                                        <td>
                                            <button onClick={() => handleRemoveFile(index)}>Remover</button>
                                        </td>
                                        <td>
                                            <select name="Respuesta" id="Respuesta" >
                                                <option value={'05'} >Aceptado</option>
                                                <option value={'06'} >Aceptado Parcial</option>
                                                <option value={'07'} >Rechazado</option>
                                            </select>
                                        </td>
                                        <td>
                                            <select name="Actividad" id="Actividad" >
                                                {MisActividades.map((actividad, index) => (
                                                    <option key={index} value={actividad.CodigoActividad}>{actividad.NombreActividad}</option>
                                                ))}
                                            </select>
                                        </td>
                                        <td>{file.tipo}</td>
                                        <td>{file.name}</td>
                                        <td>{file.consecutivo}</td>
                                        <td>{file.proveedor}</td>
                                        <td>
                                            {(() => {
                                                try {
                                                    const date = new Date(file.fecha);
                                                    const options = {
                                                        day: '2-digit',
                                                        month: '2-digit',
                                                        year: 'numeric',
                                                        hour: '2-digit',
                                                        minute: '2-digit',
                                                        hour12: true,
                                                    };
                                                    return date.toLocaleString('es-ES', options);
                                                } catch {
                                                    return file.fecha;
                                                }
                                            })()}
                                        </td>
                                        <td>
                                            {(file.moneda === 'CRC' ? '₡' : '$') +
                                                parseFloat(file.total)
                                                    .toFixed(2)
                                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                        </td>
                                        <td>{file.resultado}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                        <button style={{ maxWidth: '70px', marginTop: '10px' }} onClick={handleSave}>
                            Guardar
                        </button>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default SubirCompras;